import { Icon } from '@iconify/react'
import { Button, NavError } from '@nexans/react-ui-kit'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

function Page403() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()

  const handleGoBack = useCallback(() => navigate(-1), [navigate])
  const handleGoHome = useCallback(() => navigate('/'), [navigate])

  return (
    <NavError description={t('not_authorized.description')} error={t('not_authorized.title')}>
      <NavError.Actions>
        <Button icon={<Icon icon="mdi:arrow-back" />} variant="outlined" onClick={handleGoBack}>
          {t('actions.go_back')}
        </Button>
        <Button onClick={handleGoHome}>{t('actions.go_home')}</Button>
      </NavError.Actions>
    </NavError>
  )
}

export default Page403
